import { render, staticRenderFns } from "./PriceListTablePreview.vue?vue&type=template&id=ef195c4c&scoped=true&"
import script from "./PriceListTablePreview.vue?vue&type=script&lang=js&"
export * from "./PriceListTablePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef195c4c",
  null
  
)

export default component.exports